import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Badge, Container } from "react-bootstrap";
import g34 from "../assets/images/bg34-1.png";
import logo from "../assets/images/tiger2.png";
import qrcode from "../assets/images/qrcode.svg";
import shap from "../assets/images/shape1.png";
import "../assets/css/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import axios from "axios";
import config from "../config";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
 
const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;

        if (!email.trim() || !password.trim()) {
            toast.warning("Email and password are required.");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${config.API_BASE_URL}/cauthRoutes/customer-login`,
                {
                    email: email.trim(),
                    password: password.trim(),
                }
            );

            if (response.status === 200) {
                const authData = response.data;

                login(authData);

                toast.success(response.data.message);

                navigate("/home", { replace: true });
            }

        } catch (error) {
            console.error("Error logging in:", error);

            const errMsg =
                error?.response?.data?.message ||
                "Invalid email or password.";

            toast.error(errMsg);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>

            <Helmet>
                <title>Login | Shaadi Material</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <section className="useraccountDiv">
                <div class="fxt-shape">
                    <div class="fxt-transformX-L-50 fxt-transition-delay-1">
                        <img src={shap} alt="shap" />
                    </div>
                </div>
                <Container>
                    <Row className="mx-0 breadcrumb_part align-items-center">
                        <Col lg={8}>
                            <div className="fxt-column-wrap justify-content-center">
                                {/* <div className="fxt-animated-img">
                                    <div className="fxt-transformX-L-50 fxt-transition-delay-10">
                                        <img src={g34} alt="productimg" />
                                    </div>
                                </div> */}
                                <div>
                                    <div className="fxt-transformX-L-50 fxt-transition-delay-3">
                                        <Link to="/" className="logo me-5">
                                            <img src={logo} alt="Logo" style={{ height: '150px' }} />
                                        </Link>
                                    </div>
                                    <div className="fxt-transformX-L-50 fxt-transition-delay-5">
                                        <div className="fxt-middle-content">
                                            <h1 className="fxt-main-title">Sign In to<br /> Shaadi Material</h1>
                                            <div className="fxt-switcher-description1">If you don’t have an account
                                                <Link to="/register" className="fxt-switcher-text ms-2 fw-bold text-info">Sign Up</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="fxt-transformX-L-50 fxt-transition-delay-7">
                                    <div className="fxt-qr-code">
                                        <img src={qrcode} alt="Logo" style={{ height: '130px' }} />
                                    </div>
                                </div> */}
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="prof_content user-dash">
                                <div className="d-flex flex-column gap-2 mb-4">
                                    <label >Email</label>
                                    <InputText
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="name@example.com"
                                    />
                                </div>
                                <div className="d-flex flex-column gap-2 mb-2">
                                    <label >Password</label>
                                    <Password value={password} onChange={(e) => setPassword(e.target.value)} toggleMask feedback={false} className="w-100" />
                                </div>
                                <Link to="/forgot" className="text-info mt-4">Forgot Password?</Link>
                                <Button
                                    label={loading ? "Signing In..." : "Sign In"}
                                    className="py-2 w-100 d-block mt-4 custbuttonpink"
                                    style={{ fontSize: '22px' }}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Login;